/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_Projects_Wizard_SuccessInputs */



/**
* | output |
* | --- |
* | "Space linked to the selected projects." |
*
* @param {Linked_Projects_Wizard_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const linked_projects_wizard_success = /** @type {((inputs?: Linked_Projects_Wizard_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_Projects_Wizard_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Space mit den ausgewählten Projekten verknüpft.")
	return /** @type {LocalizedString} */ ("Space linked to the selected projects.")
});